
const login = () => import(/* webpackChunkName: "register" */ '@/views/registration/login.vue');
const sin = () => import(/* webpackChunkName: "register" */ '@/views/registration/index.vue');
const register = () => import(/* webpackChunkName: "register" */ '@/views/registration/register.vue');
const regRoute = [
    {
        path: '/sin',
        name: 'sin',
        component: sin,
        children:[
            {
                path: '/login',
                name: 'login',
                component: login
            },
            {
                path: '/register',
                name: 'register',
                component: register
            },
        ]
    },

]

export default regRoute
